(function () {
  var TOTAL_DOTS = 40;

  var LAPTOP_TONNES_FOR_COUNT = 1053 / 3120;
  var SMARTPHONE_TONNES_FOR_COUNT = 1053 / 13000;
  var AI_USER_TONNES_FOR_COUNT = 1053 / 9568;

  function formatNumber(value, decimals) {
    return Number(value || 0).toLocaleString(undefined, {
      minimumFractionDigits: decimals || 0,
      maximumFractionDigits: decimals || 0
    });
  }

  function setCounterTarget(el, value, decimals) {
    if (!el) return;

    el.setAttribute('data-target', Number(value || 0));
    el.setAttribute('data-decimals', decimals || 0);
    el.textContent = formatNumber(0, decimals || 0);
  }

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
    var duration = 1400;
    var startTime = null;

    function update(timestamp) {
      if (!startTime) startTime = timestamp;

      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;

      el.textContent = formatNumber(current, decimals);

      if (progress < 1) {
        window.requestAnimationFrame(update);
      } else {
        el.textContent = formatNumber(target, decimals);
      }
    }

    window.requestAnimationFrame(update);
  }

  function getTotalTonnesFromApi(data) {
    var totalKg = Number(
      data.total_offset_kgs ||
      data.totalOffsetKgs ||
      data.total_offset_kg ||
      data.totalOffsetKg ||
      0
    );

    if (totalKg > 0) {
      return totalKg / 1000;
    }

    return Number(
      data.total_offset_tonnes ||
      data.totalOffsetTonnes ||
      data.total_tonnes ||
      data.totalTonnes ||
      data.tonnes ||
      0
    );
  }

  function getEquivalentType(el) {
    var type = (el.getAttribute('data-equivalent') || 'auto').toLowerCase();
    var iconType = (el.getAttribute('data-icon-type') || '').toLowerCase();

    if (type === 'auto' || type === '') {
      type = iconType;
    }

    if (type === 'laptop') return 'laptops';
    if (type === 'phone') return 'smartphones';
    if (type === 'ai') return 'ai_users';

    return type;
  }

  function getEquivalentValue(type, totalTonnes, fallbackValue) {
    if (type === 'laptops') {
      return Math.round(totalTonnes / LAPTOP_TONNES_FOR_COUNT);
    }

    if (type === 'smartphones') {
      return Math.round(totalTonnes / SMARTPHONE_TONNES_FOR_COUNT);
    }

    if (type === 'ai_users') {
      return Math.round(totalTonnes / AI_USER_TONNES_FOR_COUNT);
    }

    return Number(fallbackValue || 0);
  }

  function updateEvidenceDots(el, count, maxCount) {
    var card = el.closest('.carbon-impact-card');
    if (!card) return;

    var evidenceText = card.querySelector('[data-evidence-text]');
    var dots = card.querySelectorAll('.carbon-impact-dots span');
    var progressBar = card.querySelector('.carbon-impact-progress span');

    dots.forEach(function (dot) {
      dot.classList.remove('is-filled');
    });

    if (!maxCount || maxCount <= 0) {
      if (evidenceText) evidenceText.textContent = '';
      if (progressBar) progressBar.style.setProperty('--evidence-width', '0%');
      return;
    }

    var share = count / maxCount;
    var cappedShare = Math.min(share, 1);
    var filledDots = Math.max(1, Math.round(cappedShare * TOTAL_DOTS));

    dots.forEach(function (dot, index) {
      if (index < filledDots) {
        dot.classList.add('is-filled');
      }
    });

    if (progressBar) {
      progressBar.style.setProperty('--evidence-width', (cappedShare * 100) + '%');
    }

    if (evidenceText) {
      evidenceText.textContent = filledDots + '/' + TOTAL_DOTS + ' dots';
    }
  }

  function initCarbonCreditedImpactSection(section) {
    if (!section || section.dataset.carbonImpactInitialised === 'true') return;

    section.dataset.carbonImpactInitialised = 'true';

    var apiToken = section.dataset.apiToken || '';
    var apiUrl = section.dataset.apiUrl || 'https://api.cnaught.com/v1/impact/data';

    var totalEl = section.querySelector('.js-total-tonnes');
    var equivalentEls = section.querySelectorAll('.js-carbon-equivalent');
    var counters = section.querySelectorAll('[data-count-up]');

    var hasAnimated = false;
    var dataLoaded = false;
    var inView = false;

    function applyValues(totalTonnes, useFallbackOnly) {
      setCounterTarget(totalEl, totalTonnes, 0);

      var values = [];

      equivalentEls.forEach(function (el) {
        var type = getEquivalentType(el);
        var fallbackValue = Number(el.getAttribute('data-fallback')) || 0;
        var value = useFallbackOnly ? fallbackValue : getEquivalentValue(type, totalTonnes, fallbackValue);

        values.push({
          el: el,
          value: value
        });

        setCounterTarget(el, value, 0);
      });

      var maxCount = Math.max.apply(null, values.map(function (item) {
        return item.value;
      }));

      values.forEach(function (item) {
        updateEvidenceDots(item.el, item.value, maxCount);
      });

      dataLoaded = true;

      if (inView) {
        runAnimation();
      }
    }

    function applyCnaughtData(data) {
      var totalTonnes = getTotalTonnesFromApi(data);

      if (!totalTonnes || totalTonnes <= 0) {
        applyFallbackData();
        return;
      }

      applyValues(totalTonnes, false);
    }

    function applyFallbackData() {
      var fallbackTotal = totalEl ? Number(totalEl.getAttribute('data-fallback')) : 0;
      applyValues(fallbackTotal, true);
    }

    function runAnimation() {
      if (hasAnimated || !dataLoaded) return;

      hasAnimated = true;

      counters.forEach(function (counter) {
        animateCounter(counter);
      });

      section.querySelectorAll('.carbon-impact-card').forEach(function (card, index) {
        setTimeout(function () {
          card.classList.add('is-active');
        }, 250 + index * 180);
      });
    }

    function fetchCnaughtData() {
      if (!apiToken) {
        console.warn('CNaught API token is missing. Using fallback/manual values.');
        applyFallbackData();
        return;
      }

      fetch(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + apiToken,
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          return response.text().then(function (text) {
            if (!response.ok) {
              throw new Error('CNaught API error ' + response.status + ': ' + text);
            }

            try {
              return JSON.parse(text);
            } catch (error) {
              throw new Error('Invalid CNaught JSON response: ' + text);
            }
          });
        })
        .then(function (data) {
          applyCnaughtData(data);
        })
        .catch(function (error) {
          console.error('CNaught impact fetch error:', error);
          applyFallbackData();
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            inView = true;
            runAnimation();
            observer.disconnect();
          }
        });
      }, { threshold: 0.25 });

      observer.observe(section);
    } else {
      inView = true;
      runAnimation();
    }

    fetchCnaughtData();
  }

  function initAllCarbonCreditedImpactSections(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-carbon-credited-impact-section]');

    sections.forEach(function (section) {
      initCarbonCreditedImpactSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllCarbonCreditedImpactSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllCarbonCreditedImpactSections(event.target);
  });
})();